import { CardElement } from '@stripe/react-stripe-js'

import { LinearProgress } from '@material-ui/core'

const CardPayment = ({
  stripe,
  elements,
  prepaymentSignup,
  onSuccess,
  amount,
  formData,
  showError,
}) => {
  const dispatch = useDispatch()
  const act = useAct()
  const [paymentEvent, setPaymentEvent] = useState()

  const handle3DSecureFlow = (result) => {
    if (result.error) {
      showError(result.error)
    } else {
      axios
        .post('/api/donations/pay', {
          amount,
          payment_intent_id: result.paymentIntent.id,
        })
        .then(function (confirmResult) {
          handleServerResponse(confirmResult)
        })
    }
  }

  const handleServerResponse = (response) => {
    if (response.data.error) {
      showError(response.data.error)
      setPaymentEvent(null)
    } else if (response.data.requires_action) {
      // 3D Secure payment - handle
      stripe
        .handleCardAction(response.data.payment_intent_client_secret)
        .then(handle3DSecureFlow)
    } else {
      console.log('Donation made successfully')
      onSuccess()
    }
  }

  const signupSuccess = useSelector((state) => state.local.signupSuccess)

  useEffect(() => {
    if (signupSuccess) {
      createPayment(paymentEvent)
    } else if (signupSuccess === false) {
      setPaymentEvent(null)
    }

    // reset signupSuccess, or it won't retrigger if a second error comes through
    dispatch({
      type: 'local/upsert',
      payload: { signupSuccess: null },
    })
  }, [signupSuccess])

  const prepayment = (evt) => {
    setPaymentEvent(evt)
    if (prepaymentSignup) {
      dispatch({
        type: 'local/upsert',
        payload: { doSignup: true },
      })
    } else createPayment(evt)
  }

  const createPayment = async (event) => {
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return
    }

    const cardElement = elements.getElement(CardElement)
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    })
    if (error) {
      showError(error)
      setPaymentEvent(null)
    } else {
      axios
        .post('/api/donations/pay', {
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          amount,
          payment_method_id: paymentMethod.id,
        })
        .then((response) => {
          act.donation.upsert({ paymentIntentId: response.data.id })
          handleServerResponse(response)
        })
    }
  }

  return (
    <div>
      <div style={{ width: '100%', pointerEvents: !paymentEvent ? 'inherit' : 'none' }}>
        <div
          style={{
            width: 'calc(100% - 12px)',
            margin: '24px 3px 24px 0px',
            padding: '18px 0 18px 10px',
            borderRadius: 3,
            border: '1px solid #c6cfd9',
            backgroundColor: 'white',
          }}
        >
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  color: '#424770',
                  '::placeholder': {
                    color: '#aab7c4',
                  },
                },
                invalid: {
                  color: '#9e2146',
                },
              },
            }}
          />
        </div>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          onClick={prepayment}
          disabled={!!paymentEvent}
        >
          {`Donate £${amount / 100} now`}
        </Button>
      </div>
      <div style={{ display: !!paymentEvent ? 'block' : 'none' }}>
        <Typography variant="body2" gutterBottom>
          Making payment...
        </Typography>
        <LinearProgress />
      </div>
    </div>
  )
}

export default CardPayment
